export default "__VITE_ASSET__2411ab0f__"